const getBrands = () => new URLSearchParams(window.location.search).get("brands") ?? "";

export default getBrands;
